import JoalAppBar from './appbar.component';

export default JoalAppBar;
